import React from 'react';
export const Header = () => {
  return <header className="border-b border-gray-200 sticky top-0 bg-gray-50 z-10" data-id="element-122">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex justify-center items-center" data-id="element-123">
                {/* Publication Title, now centered and without distractions */}
                <div className="text-2xl font-extrabold text-teal-600 tracking-tight" data-id="element-124">
                    Wellness Today
                </div>
            </div>
        </header>;
};
export default Header;